export default __webpack_public_path__ + "static/Banner-Suite-1-e6bb8605a7df19e85c7893550fbd2df7.jpg";